import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import VueDraggable from 'vuedraggable';
import { ConfigConsumerProps } from '../config-provider';

// 该算法将原数据中被筛选过的数据进行排序，其余数据顺序不变
function getChangedDataSource(oldData, newData) {
  var ret = [];
  var j = 0;
  for (var i = 0; i < oldData.length; i++) {
    if (newData.indexOf(oldData[i]) > -1) {
      ret.push(newData[j++]);
    } else {
      ret.push(oldData[i]);
    }
  }
  return ret;
}

function toBool(s) {
  return !!s;
}

var eventsToEmit = ['Move', 'Choose', 'Unchoose', 'Sort', 'Filter', 'Clone'];

var DraggableBodyWrapper = {
  name: 'DraggableBodyWrapper',

  props: {
    rowDraggable: Object,
    dataSource: Array
  },

  inject: {
    table: { 'default': function _default() {
        return {};
      } },
    configProvider: { 'default': function _default() {
        return ConfigConsumerProps;
      } }
  },

  data: function data() {
    return {
      dragging: false
    };
  },


  methods: {
    handleInput: function handleInput(newData) {
      var _$props = this.$props,
          rowDraggable = _$props.rowDraggable,
          oldData = _$props.dataSource;


      if (rowDraggable.onChange) {
        var changedDataSource = getChangedDataSource(oldData, newData);
        rowDraggable.onChange({ currentDataSource: changedDataSource });
      }
    },
    handleStart: function handleStart(evt) {
      this.dragging = true;

      this.triggerOptsEvt('onStart', evt);
    },
    handleEnd: function handleEnd(evt) {
      this.dragging = false;

      this.triggerOptsEvt('onEnd', evt);
    },
    triggerOptsEvt: function triggerOptsEvt(evtName, evt) {
      var _$props$rowDraggable$ = this.$props.rowDraggable.options,
          options = _$props$rowDraggable$ === undefined ? {} : _$props$rowDraggable$;

      if (options[evtName]) {
        options[evtName](evt);
      }
    }
  },

  render: function render() {
    var _classes,
        _this = this;

    var h = arguments[0];

    // prefixCls
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('table');
    var rowDraggable = this.$props.rowDraggable;
    var data = this.table.data;

    // draggableOptions
    // https://github.com/SortableJS/Sortable#options

    var _rowDraggable$options = rowDraggable.options,
        customizeDraggableOptions = _rowDraggable$options === undefined ? {} : _rowDraggable$options;

    var defaultDraggableOptions = {
      chosenClass: prefixCls + '-draggable-chosen',
      ghostClass: prefixCls + '-draggable-ghost',
      animation: 150
    };
    var draggableOptions = _extends({}, defaultDraggableOptions, customizeDraggableOptions);

    // class
    var classes = (_classes = {}, _defineProperty(_classes, prefixCls + '-tbody-has-draggable-row', true), _defineProperty(_classes, prefixCls + '-tbody-has-draggable-disabled', draggableOptions.disabled), _defineProperty(_classes, prefixCls + '-tbody-has-draggable-handle', toBool(draggableOptions.handle)), _defineProperty(_classes, prefixCls + '-tbody-has-dragging-row', this.dragging), _classes);

    var listenters = eventsToEmit.reduce(function (res, key) {
      res[key.toLowerCase()] = function (evt) {
        _this.triggerOptsEvt('on' + key, evt);
        // console.log('calling', key);
      };
      return res;
    }, {});

    return h(
      VueDraggable,
      _mergeJSXProps([{
        attrs: {
          tag: 'tbody'
          // options={draggableOptions}
          ,
          value: data
        },
        'class': classes, on: {
          'input': this.handleInput,
          'start': this.handleStart,
          'end': this.handleEnd
        }
      }, { on: listenters, attrs: draggableOptions }, {
        attrs: {
          move: listenters.move
        }
      }]),
      [this.$slots['default']]
    );
  }
};

var createCustomizedBodyWrapper = function createCustomizedBodyWrapper() {
  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tbody';

  var CustomizedBodyWrapper = {
    name: 'CustomizedBodyWrapper',

    props: {
      rowDraggable: {
        type: Object,
        'default': function _default() {
          return {};
        }
      },
      dataSource: {
        type: Array,
        'default': function _default() {
          return [];
        }
      },
      sortOrder: {
        type: String
      }
    },

    inject: {
      table: { 'default': function _default() {
          return {};
        } }
    },

    render: function render() {
      var h = arguments[0];
      var _table = this.table,
          expandedRowRender = _table.expandedRowRender,
          expander = _table.expander,
          columnManager = _table.columnManager;
      var _$props2 = this.$props,
          rowDraggable = _$props2.rowDraggable,
          dataSource = _$props2.dataSource,
          sortOrder = _$props2.sortOrder;

      // 升降排序

      var hasSortOrder = toBool(sortOrder);
      // 额外的展开行
      var hasExpandedRowRender = toBool(expandedRowRender);
      // 树形数据的展示
      var hasIndentSpaced = expander.needIndentSpaced;
      // 固定列

      var hasLeftFixed = columnManager.isAnyColumnsLeftFixed();
      var hasRightFixed = columnManager.isAnyColumnsRightFixed();

      // 与拖拽排序互斥
      var allowDraggable = !(hasSortOrder || hasExpandedRowRender || hasIndentSpaced || hasLeftFixed || hasRightFixed);

      if (allowDraggable) {
        return h(
          DraggableBodyWrapper,
          _mergeJSXProps([{
            attrs: {
              rowDraggable: rowDraggable,
              dataSource: dataSource
            }
          }, this.$props]),
          [this.$slots['default']]
        );
      }

      return h(
        Component,
        this.$props,
        [this.$slots['default']]
      );
    }
  };

  return CustomizedBodyWrapper;
};

export default createCustomizedBodyWrapper;